import { styled } from '@mui/material';

import { SettingsOutlineIcon } from '@app-velocity/icons';
import { useCurrentUser } from '@app-velocity/libs/auth';
import { MessageBus } from '@app-velocity/message-bus';

import { useReportContext } from '../../context/useReportContext';
import { useReportConfigSettings } from '../../hooks/useReportConfigSettings';
import { UsedConfigInfo } from './components/UsedConfigInfo';

const RequirementsButton = styled('button')(({ theme }) => ({
  background: 'transparent',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: 0,
  cursor: 'pointer',
  color: '#969696',
  svg: {
    fill: '#969696',
  },
}));

export type ReportRequirementsProps = {
  workspaceId?: string;
  prototypeId?: string;
  reportType: 'figma' | 'vibe';
};

const messageBus = new MessageBus('prototypes');

export const ReportRequirements = ({
  workspaceId,
  prototypeId,
  reportType,
}: ReportRequirementsProps) => {
  const currentUser = useCurrentUser();
  const { reportConfig, type } = useReportContext();
  const { getUsedConfigLabel } = useReportConfigSettings();

  const usedConfigLabel = getUsedConfigLabel(
    reportConfig.config,
    type === 'vibe' ? 'WEBSITE' : 'FIGMA_PROTOTYPE',
    'report'
  );

  const handleOpenReportConfig = () => {
    if (!workspaceId || !prototypeId) return;

    messageBus.publish('modal:report-config:open', {
      workspaceId,
      prototypeId,
      reportType,
      mode: 'report',
    });
  };

  if (!currentUser?.authorized) {
    return <UsedConfigInfo usedConfig={usedConfigLabel} />;
  }

  return (
    <RequirementsButton type="button" onClick={handleOpenReportConfig}>
      <UsedConfigInfo usedConfig={usedConfigLabel} />
      <SettingsOutlineIcon />
    </RequirementsButton>
  );
};
